const divTenantSelector = {
  notActiveBadge: 'Não Ativado',
  access: 'Você não possui nenhuma empresa atribuída',
  blocked: 'Bloqueado'
};

export default divTenantSelector;
